import React, {Suspense} from 'react';
import logo from './logo.svg';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'antd/dist/antd.css';
import './App.css';
import {
  HashRouter as Router,
  Route,
  Redirect,
  Switch,
} from "react-router-dom";
import {Spin} from 'antd';
import history from './history';
import ErrorBoundary from './ErrorBoundary'

const DefaultLayout = React.lazy(() => import('./Layout/DefaultLayout'));
const Login = React.lazy(() => import('./container/Login'));
const FirstLogin = React.lazy(() => import('./container/FirstLogin'));


const AppRoute = () => {
  return (
    // <ErrorBoundary fallback={<h1 style={{textAlign:"center", marginTop: "15px"}}>Không thể kết nối tới máy chủ</h1>}>
      <Suspense fallback={<div className="loading-component"><Spin size="large" tip="Loading..."/></div>}>
        <Router history={history}>
          <Switch>
            <Redirect exact from="/" to="/login" />
            <Route exact path="/login" component={Login} />
            <Route exact path="/change-new-password" component={FirstLogin} />
            <Route path="/" component={DefaultLayout} />
          </Switch>
        </Router>
      </Suspense>
    // </ErrorBoundary>
  )
}

function App() {
  return (
    <div className="App">
      <AppRoute />
    </div>
  );
}

export default App;
